import React from "react"
import Icon from "../../Utils/Icon"
// import * as styles from "./Styles/Filter.module.scss"
import "../../../styles/layouts"
import classNames from "classnames/bind"
// const cn = classNames.bind(styles)

const Sort = (props) => {
  return <div></div>
}
export default Sort
